import { isBD } from "../../utils/businessType.lib.js";
import { AD_CURATION_COSTCO } from "../../components/Marketing/AdSetCostco/constants.js";
import { parseBatchedItemResponse as parseBatchedItemResponse$1 } from "./normalizePCP/lib.js";
import { parseBatchedItemResponse } from "./normalizePCP_V2/lib.js";
import { generateProductGraphQlQuery } from "./productQuery.js";
async function productService(itemNumber, productConfig, locale, bdWHNumber, itemCuration, product_tile_data_source) {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const {
    productApiConfig,
    productDetailApiConfig,
    productDetailApiV2Config,
    featureToggleConfig
  } = productConfig;
  const callProductSummaryAPI = ((_a = featureToggleConfig == null ? void 0 : featureToggleConfig.callProductSummaryAPI) == null ? void 0 : _a.isEnabled) || product_tile_data_source === "product_summary_api";
  const { apiUrl, clientId, warehouseNumber, clientIdHeader } = callProductSummaryAPI ? ((_b = featureToggleConfig == null ? void 0 : featureToggleConfig.warehousePriceOnline) == null ? void 0 : _b.isEnabled) ? productDetailApiV2Config : productDetailApiConfig : productApiConfig;
  const env = callProductSummaryAPI ? process.env.NEXT_PUBLIC_CONTENT_ENTRY_COSTCO_ENV_HEADER_CONFIGURATION : productApiConfig == null ? void 0 : productApiConfig.env;
  if (!apiUrl || !clientId || !env || !warehouseNumber) return null;
  if (callProductSummaryAPI) {
    try {
      const response = await fetch(
        `${apiUrl}/summary?clientId=${clientId}&items=${itemNumber}&whsNumber=${isBD() && bdWHNumber ? bdWHNumber : warehouseNumber}`,
        {
          headers: new Headers({
            "client-identifier": clientIdHeader ?? "",
            "costco-env": env
          }),
          method: "GET"
        }
      );
      if (itemCuration === AD_CURATION_COSTCO) {
        const parseBatchedResponse = ((_c = featureToggleConfig == null ? void 0 : featureToggleConfig.warehousePriceOnline) == null ? void 0 : _c.isEnabled) ? parseBatchedItemResponse : parseBatchedItemResponse$1;
        return parseBatchedResponse(itemNumber, response);
      } else {
        const productApiResponseData = await response.json();
        const inventoryItemNumbers = ((_e = (_d = productApiResponseData == null ? void 0 : productApiResponseData.productData) == null ? void 0 : _d[0].childCatalogData) == null ? void 0 : _e.map((item) => item.id).map(Number)) || [];
        return {
          inventoryItemNumbers,
          productApiResponseData
        };
      }
    } catch (error) {
      console.error(
        "Error fetching product data from Product Summary API:",
        error
      );
      return null;
    }
  } else {
    const headers = {
      "Content-Type": "application/json",
      "client-identifier": clientId,
      "costco.env": env,
      "costco.service": "restProduct"
    };
    const requestDataQuery = generateProductGraphQlQuery(
      [itemNumber],
      isBD() && bdWHNumber ? bdWHNumber : warehouseNumber,
      clientId,
      locale,
      productApiConfig == null ? void 0 : productApiConfig.custom_properties
    );
    try {
      const response = await fetch(apiUrl, {
        body: JSON.stringify(requestDataQuery),
        headers,
        method: "POST"
      });
      const productApiResponseData = await response.json();
      const childCatalogData = ((_h = (_g = (_f = productApiResponseData == null ? void 0 : productApiResponseData.data) == null ? void 0 : _f.products) == null ? void 0 : _g.childData) == null ? void 0 : _h.catalogData) || [];
      const itemArray = childCatalogData == null ? void 0 : childCatalogData.map(
        (item) => item.itemNumber
      );
      const inventoryItemNumbers = itemArray.map(Number);
      return {
        inventoryItemNumbers,
        productApiResponseData
      };
    } catch (err) {
      console.error("Product Api fetch failed", err);
      return null;
    }
  }
}
export {
  productService
};
